export default ({axios}) => ({
    index: () => axios.get(`/dashboard`),
})
